import formatDate from "./formatDate";

// NOTE 시간 간격을 계산하는 함수
export const calculateInterval = (start: Date, end: Date) => {
  if (!start || !end) return null;

  if (formatDate(start) === formatDate(end)) {
    return formatTimeInterval(start, end);
  }

  const timeDiffMilliseconds = Math.abs(end.getTime() - start.getTime());
  const hours = Math.floor(timeDiffMilliseconds / (60 * 60 * 1000));
  return hours <= 24 ? formatTimeInterval(start, end) : null;
};

// NOTE 시간 간격 포멧팅 하는 함수
export const formatTimeInterval = (start: Date, end: Date) => {
  const timeDiffMilliseconds = Math.abs(end.getTime() - start.getTime());
  const hours = Math.floor(timeDiffMilliseconds / (60 * 60 * 1000));
  const minutes = Math.floor((timeDiffMilliseconds % (60 * 60 * 1000)) / (60 * 1000));

  return `${hours == 0 ? "" : hours + "h "}${minutes == 0 ? "" : minutes + "min"}`;
};
